import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { X, Cookie } from "lucide-react";
import { Link } from "react-router-dom";

export function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setShow(true);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookie-consent', 'all');
    setShow(false);
  };

  const acceptNecessary = () => {
    localStorage.setItem('cookie-consent', 'necessary');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[70] max-h-[min(70dvh,32rem)] overflow-y-auto border-t bg-card px-4 pb-[max(1rem,env(safe-area-inset-bottom))] pt-4 shadow-lg md:p-6" role="region" aria-label="Préférences de cookies">
      <div className="container mx-auto">
        <div className="relative flex flex-col items-start justify-between gap-4 pr-10 md:flex-row md:items-center md:pr-0">
          <div className="flex items-start gap-3 flex-1">
            <Cookie className="w-6 h-6 text-primary mt-1 flex-shrink-0" />
            <div className="space-y-1">
              <p className="text-sm font-medium">
                🍪 Nous utilisons des cookies
              </p>
              <p className="text-xs text-muted-foreground">
                Pour améliorer ton expérience et assurer la sécurité de la plateforme. 
                En continuant, tu acceptes notre utilisation des cookies.{" "}
                <Link to="/legal/cookies" className="underline hover:text-primary">
                  En savoir plus
                </Link>
              </p>
            </div>
          </div>

          <div className="flex w-full flex-col gap-2 sm:flex-row md:w-auto">
            <Button 
              variant="outline" 
              size="sm" 
              onClick={acceptNecessary}
              className="flex-1 md:flex-none"
            >
              Nécessaires uniquement
            </Button>
            <Button 
              size="sm" 
              onClick={acceptAll}
              className="flex-1 md:flex-none"
            >
              Tout accepter
            </Button>
          </div>

          <Button
            variant="ghost"
            size="icon"
            onClick={() => setShow(false)}
            className="absolute -right-2 -top-2 md:relative md:right-0 md:top-0"
            aria-label="Fermer la bannière de cookies"
          >
            <X className="w-4 h-4" />
          </Button>
        </div>
      </div>
    </div>
  );
}
